// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/So_AdditionalServiceFiscalInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/additional_service_fiscal/salvar
 *
 * Creates or updates the fiscal sidecar row for
 * (so_additional_service_fiscal_additional_service_id,
 * so_additional_service_fiscal_franchise_id). so_additional_service_fiscal_franchise_id
 * = null means the global (franqueadora) row; an int overrides it for that
 * franchise only.
 */
import { registerContract } from './validate'

export interface So_AdditionalServiceFiscalInput {
so_additional_service_fiscal_additional_service_id: number
so_additional_service_fiscal_franchise_id?: number
so_additional_service_fiscal_lc116_code?: string
so_additional_service_fiscal_municipal_service_code?: string
so_additional_service_fiscal_iss_aliquota?: number
so_additional_service_fiscal_iss_retido_default?: number
so_additional_service_fiscal_municipio_incidencia_ibge?: string
so_additional_service_fiscal_cnae?: string
so_additional_service_fiscal_codigo_tributacao_nacional?: string
}

registerContract('So_AdditionalServiceFiscalInput', {
  so_additional_service_fiscal_additional_service_id:      { type: 'number',  required: true },
  so_additional_service_fiscal_franchise_id:               { type: 'number',  required: false },
  so_additional_service_fiscal_lc116_code:                 { type: 'string',  required: false },
  so_additional_service_fiscal_municipal_service_code:     { type: 'string',  required: false },
  so_additional_service_fiscal_iss_aliquota:               { type: 'number',  required: false },
  so_additional_service_fiscal_iss_retido_default:         { type: 'number',  required: false },
  so_additional_service_fiscal_municipio_incidencia_ibge:  { type: 'string',  required: false },
  so_additional_service_fiscal_cnae:                       { type: 'string',  required: false },
  so_additional_service_fiscal_codigo_tributacao_nacional: { type: 'string',  required: false },
})
